import { render, staticRenderFns } from "./SummaryVisaVisitRevenuePage.vue?vue&type=template&id=864ac43a&scoped=true&"
import script from "./SummaryVisaVisitRevenuePage.vue?vue&type=script&lang=js&"
export * from "./SummaryVisaVisitRevenuePage.vue?vue&type=script&lang=js&"
import style0 from "./SummaryVisaVisitRevenuePage.vue?vue&type=style&index=0&id=864ac43a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864ac43a",
  null
  
)

export default component.exports